import { Page } from 'layouts/Page';
import { FC } from 'react';
import { GpsrProductTypes } from 'components/GpsrProductTypes';

export const GpsrProductTypePage: FC = () => {
	return (
		<Page title="GPSR Management – EAS Control Center">
			<GpsrProductTypes />
		</Page>
	);
};
